/* eslint-disable react/no-unescaped-entities */
import { Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import Seo from '../Seo';
import { CONTACT_EMAIL, PAGE_SEO, SITE_NAME, SITE_URL } from '../../utils/seo';
import './index.css';

export default function PrivacyPolicy() {
  return (
    <Row style={{ display: 'flex', justifyContent: 'center', margin: '20px' }}>
      <Seo
        title={PAGE_SEO.PRIVACY.title}
        description={PAGE_SEO.PRIVACY.description}
        canonical={`${SITE_URL}/privacy-policy`}
      />
      <Col span={18} md={18} xs={24}>
        <h1 className="card-category text-gray title-name">Privacy Policy</h1>
        <p className="date-display">Last updated: August 14, 2026</p>

        <p className="des-para">
          This Privacy Policy describes how {SITE_NAME} (“we”, “us”) collects, uses, and shares
          information when you visit {SITE_URL} (the “Service”). By using the Service, you agree to
          this policy.
        </p>

        <h2>Information we collect</h2>
        <h3>Information you provide</h3>
        <p className="des-para">
          If you use the contact form, we collect your name, email address, and message so we can
          respond. We do not require an account to browse fixtures or articles.
        </p>
        <h3>Information collected automatically</h3>
        <p className="des-para">
          Like most websites, we collect usage data such as IP address, browser type, device type,
          pages visited, referring URL, and timestamps. This data is used for security, analytics, and
          to improve the Service.
        </p>

        <h2>Cookies and similar technologies</h2>
        <p className="des-para">
          We use cookies and similar technologies. You can refuse cookies in your browser settings.
          Some features may not work without them.
        </p>
        <ul>
          <li>
            <strong>Essential cookies:</strong> required for basic site operation and security.
          </li>
          <li>
            <strong>Analytics cookies:</strong> we use Google Analytics (measurement ID G-9QPDCDK6RY)
            to understand how visitors use the site. Google may process this data under its own
            privacy policy.
          </li>
          <li>
            <strong>Advertising cookies:</strong> if third-party ads are displayed, those partners may
            set their own cookies. We do not control those cookies.
          </li>
        </ul>

        <h2>How we use information</h2>
        <ul>
          <li>To operate, maintain, and improve the Service.</li>
          <li>To respond to contact and DMCA requests.</li>
          <li>To measure traffic and diagnose technical issues.</li>
          <li>To comply with law and enforce our Terms of Service.</li>
        </ul>

        <h2>How we share information</h2>
        <p className="des-para">We do not sell your personal information. We may share information:</p>
        <ul>
          <li>With service providers who help us host, analyze, or send email, under confidentiality obligations.</li>
          <li>When required by law, court order, or to protect rights, safety, or security.</li>
          <li>In connection with a merger, sale, or transfer of assets, with notice where required.</li>
        </ul>

        <h2>Retention</h2>
        <p className="des-para">
          We keep contact messages only as long as needed to handle your request and for legitimate
          legal or security purposes. Analytics data is retained according to our analytics provider’s
          settings.
        </p>

        <h2>Your rights</h2>
        <p className="des-para">
          Depending on where you live, you may have rights to access, correct, delete, or restrict
          processing of your personal data, and to object to certain processing. To make a request,
          email {CONTACT_EMAIL} or use our <Link to="/contact-us">contact form</Link>. We may need to
          verify your identity.
        </p>

        <h2>International transfers</h2>
        <p className="des-para">
          The Service may be hosted or processed in countries other than your own. By using the
          Service, you understand that your information may be transferred to those locations.
        </p>

        <h2>Children</h2>
        <p className="des-para">
          The Service is not directed to children under 13, and we do not knowingly collect personal
          information from children under 13. If you believe a child has provided us with personal
          information, contact us and we will delete it.
        </p>

        <h2>Third-party websites</h2>
        <p className="des-para">
          The Service may link to websites we do not operate. Their privacy practices are their own.
          Review those policies before providing information to them.
        </p>

        <h2>Security</h2>
        <p className="des-para">
          We use reasonable administrative and technical measures to protect information. No method of
          transmission or storage is completely secure.
        </p>

        <h2>Changes</h2>
        <p className="des-para">
          We may update this Privacy Policy. The “Last updated” date will change when we do. Material
          changes may also be noted on the Service.
        </p>

        <h2>Contact</h2>
        <p className="des-para">
          Privacy questions: {CONTACT_EMAIL} or our <Link to="/contact-us">contact form</Link>. For
          copyright notices, see the <Link to="/dmca">DMCA Policy</Link>.
        </p>
      </Col>
    </Row>
  );
}
